import * as Yup from "yup"

/**
 * Gets the sign in schema with custom error messages
 *
 * @param {{email: string, required: string}} [errorMessages]
 * @returns {Yup.ObjectSchema}
 */
export function getSignInSchema(errorMessages) {
  return Yup.object({
    email: Yup.string().trim().email(errorMessages?.email).required(errorMessages?.required),
    password: Yup.string().required(errorMessages?.required),
  }).required()
}
